import { DOM } from '../data/index.js';

/**
 * Handles favicons for both SSR and CSR.
 * @param ssrHtml - Optional: The HTML string for SSR. If provided, favicons are injected.
 * @returns For SSR, returns modified HTML. For CSR, returns a cleanup function.
 */
function setFavicons(ssrHtml) {
    if (ssrHtml !== undefined) {
        if (ssrHtml.includes('data-favicons'))
            return ssrHtml;
        return ssrHtml.replace('</head>', `${DOM}</head>`);
    }
    if (typeof document !== 'undefined') {
        if (document.head.querySelector('meta[data-favicons]'))
            return () => { };
        document.head.insertAdjacentHTML('beforeend', DOM);
        return () => {
            const injectedElements = document.head.querySelectorAll('[data-favicons]');
            injectedElements?.forEach(el => el.remove());
        };
    }
    return null;
}

export { setFavicons };
